import officer1 from "../assets/images/president.jpeg";
import officer2 from "../assets/images/ajibade.png";
import officer3 from "../assets/images/uduak.png";
import officer4 from "../assets/images/arugwu.png";
import officer5 from "../assets/images/gabriel.png";
import officer6 from "../assets/images/ajeniyi.png";
import officer7 from "../assets/images/nura.png";
import officer8 from "../assets/images/blessed.png";
import officer9 from "../assets/images/gabriel2.png";
import officer10 from "../assets/images/oyeniyi.png";
import officer11 from "../assets/images/aliyu.png";
import officer12 from "../assets/images/basirat.png";
import officer13 from "../assets/images/samira.png";
import officer14 from "../assets/images/edna.png";
import officer15 from "../assets/images/garba.png";
import officer16 from "../assets/images/chris.png";
import officer17 from "../assets/images/ochuko.png";
import officer18 from "../assets/images/aliyu2.png";
import officer19 from "../assets/images/nonye.png";
import officer20 from "../assets/images/kunle.png";
import officer21 from "../assets/images/stephen.png";
import officer22 from "../assets/images/tabitha.png";
export const executiveMembers = [
  {
    id: 1,
    name: "SAMIRA JIBIR (Ph.D)",
    profileImg: officer13,
    portfolio: "National President (NAPPS NIGERIA)",
  },
  {
    id: 2,
    name: "COMRADE AJIBADE AUGUSTINE",
    profileImg: officer2,
    portfolio: "National Secretary, (NAPPS NIGERIA)",
  },
  {
    id: 3,
    name: "UDUAK MOYCE ETUK",
    profileImg: officer3,
    portfolio: "Assistant National Secretary (NAPPS NIGERIA)",
  },
  {
    id: 4,
    name: "CHIEF ARUGWU ANDERSON",
    profileImg: officer4,
    portfolio: "National Treasurer (NAPPS NIGERIA)",
  },
  {
    id: 5,
    name: "HON (REV.) GABRIEL OSA IGBINIJESU (J.P)",
    profileImg: officer5,
    portfolio: "National Publicity Secretary (NAPPS NIGERIA)",
  },
  {
    id: 6,
    name: "AJENIYI, GIDEON OYEBAMIJI",
    profileImg: officer6,
    portfolio: "National Auditor (NAPPS NIGERIA)",
  },
  {
    id: 7,
    name: "HON. ALH. NURA ISA MUSA",
    profileImg: officer7,
    portfolio: "National Welfare/ Organizing Secretary II",
  },
  {
    id: 8,
    name: "COMRADE BLESSED OGBUEHI",
    profileImg: officer8,
    portfolio: "National Assistant Fin. Secretary",
  },
  {
    id: 9,
    name: "HON (REV.) GABRIEL OSA IGBINIJESU (J.P)",
    profileImg: officer9,
    portfolio: "National Publicity Secretary (NAPPS NIGERIA)",
  },
  {
    id: 10,
    name: "OYENIYI SULYMAN ADEKUNLE",
    profileImg: officer10,
    portfolio: "National Financial Secretary (NAPPS NIGERIA)",
  },
];
export const zonalPresidents = [
  {
    id: 1,
    name: "ALIYU SULYMAN ADEKUNLE",
    profileImg: officer11,
    portfolio: "National Council Member (North East Zone)",
  },
  {
    id: 2,
    name: "ALHAJA BASIRAT A. ALIMI",
    profileImg: officer12,
    portfolio: "National Council Member (South West Zone)",
  },
  {
    id: 3,
    name: "DR. EDNA TAMUNOKIKAYEOFORI OPARA",
    profileImg: officer14,
    portfolio: "National Council Member (South South Zone)",
  },
  {
    id: 4,
    name: "Alh. GARBA M. KILGORI",
    profileImg: officer15,
    portfolio: "National Council Member (North West Zone)",
  },
  {
    id: 5,
    name: "PASTOR CHRIS I. INEH",
    profileImg: officer16,
    portfolio: "National Council Member (South East Zone)",
  },
  {
    id: 6,
    name: "DR OCHUKO AKPEME RDN",
    profileImg: officer17,
    portfolio: "National Vice-President (South South Zone)",
  },
  {
    id: 7,
    name: "HON DR. ALIYU RABIU KURFI",
    profileImg: officer18,
    portfolio: "National Vice-President (North West Zone)",
  },
  {
    id: 8,
    name: "NONYE ENEMUO (Esq)",
    profileImg: officer19,
    portfolio: "National Vice-President (South East Zone)",
  },
  {
    id: 9,
    name: "DR. KUNLE GBADAMOSI (Ph.D)",
    profileImg: officer20,
    portfolio: "National Vice-President (North East Zone)",
  },
  {
    id: 10,
    name: "PASTOR (Barr.) STEPHEN O. ABITOGUN",
    profileImg: officer21,
    portfolio: "National Vice-President (South West Zone)",
  },
  {
    id: 11,
    name: "SALAUDEEN TABITHA MSURSHIMA",
    profileImg: officer22,
    portfolio: "National Vice-President (North Central Zone)",
  },
];
